module.exports = __webpack_public_path__ + "static/energy_private_9-f65516bee828f3e0f64579fc4002687c.jpg";